<app-bar [queGame]="''"></app-bar>




<div (click)="aceptCookie()">

  <div id="mycookie" class=" alert negro-alert alert-warning alert-dismissible fade show" role="alert" data-dismiss="alert" aria-label="Close">

    <p><strong>Attention: </strong>This website uses its own and third-party cookies to offer a better service.<br /> If you continue browsing we consider that you accept its use and you affirm that you are over 18 years of age
    </p>


  </div>

<div class="iuno">
  <div class="ilogo">
    <img src="/assets/inicio/log.png" class="imagen">
    <h2>Games online</h2>
  </div>


</div>


  <div class="ilogoTitle">
    <h2>Enjoy our online games completely free</h2>
  </div>






  <div class="moonshot base" routerLink="/game/Moonshot">
    <h2>Moonshot</h2>

  </div>


<!--<div class="publicidad">


</div>-->

<div class="chess base" routerLink="/game/Chess">
  <h2>Chess</h2>

</div>


</div>


